"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var getKeys_1 = __importDefault(require("@zapier/common-utils/dist/getKeys"));
var get = function (thing, keys, defaultValue) {
    var context = null;
    var keyIndex = 0;
    var keysArray = getKeys_1.default(keys);
    while (keyIndex < keysArray.length && thing != null) {
        var key = keysArray[keyIndex];
        if (lodash_1.isArray(key)) {
            if (typeof thing === 'function') {
                thing = thing.apply(context, key);
                context = null;
            }
            else {
                thing = undefined;
            }
        }
        else if (thing != null) {
            context = thing;
            // @ts-ignore
            thing = thing[key];
        }
        keyIndex++;
    }
    if (thing == null && defaultValue != null) {
        return defaultValue;
    }
    return thing;
};
exports.default = get;
